import { Component } from '@angular/core';

@Component({
  selector: 'app-password-requirements',
  standalone: true,
  imports: [],
  templateUrl: './password-requirements.component.html',
  styleUrl: './password-requirements.component.scss'
})
export class PasswordRequirementsComponent {

}
